var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page",
    {
      attrs: {
        "view-slug": "icon-discovery",
        "is-showing-v7-prerelease-notice": true,
      },
    },
    [
      _c("wa-page-header", { attrs: { slot: "header" }, slot: "header" }),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "app-content",
          staticStyle: {
            "--desktop-grid-max-width": "var(--viewport-desktop)",
          },
          attrs: { slot: "content", role: "main" },
          slot: "content",
        },
        [
          _vm.isLoading
            ? _c("wa-icons-loading")
            : _c(
                "ais-instant-search",
                {
                  ref: "instantSearch",
                  attrs: {
                    "search-client": _vm.searchClient,
                    "index-name": _vm.index,
                    routing: _vm.routing,
                    middlewares: _vm.middlewares,
                    "search-parameters": { clickAnalytics: true },
                    "insights-client": _vm.insightsClient,
                    future: { preserveSharedStateOnUnmount: true },
                  },
                },
                [
                  _c("ais-configure", {
                    attrs: {
                      hitsPerPage: _vm.pageSize,
                      distinct: false,
                      facetFilters: _vm.facetFilters,
                      filters: _vm.filters,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      staticClass: "padding-top-2xl",
                      staticStyle: { background: "var(--white)" },
                      attrs: { id: "search-header" },
                    },
                    [
                      _c("div", { staticClass: "container" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "margin-bottom-2xl margin-auto laptop:line-length-xl",
                          },
                          [
                            _c("h1", { staticClass: "sr-only" }, [
                              _vm._v("Font Awesome Icons"),
                            ]),
                            _vm._v(" "),
                            _c("ais-search-box", {
                              attrs: { id: "aisSearchBox" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function ({ currentRefinement }) {
                                    return [
                                      _c("input-term", {
                                        staticStyle: {
                                          "--input-placeholder-color":
                                            "var(--fa-md-gravy)",
                                        },
                                        attrs: {
                                          term: _vm.searchTerm,
                                          label: `Search the v${_vm.$releases.active.versionParts.major} Icons`,
                                          "is-showing-clear-button":
                                            !!currentRefinement,
                                        },
                                        on: {
                                          input: (term) =>
                                            _vm.setSearchTerm(term),
                                          clear: function ($event) {
                                            return _vm.clearSearch("search-bar")
                                          },
                                          focus: function ($event) {
                                            _vm.searchFieldFocus = true
                                          },
                                          blur: function ($event) {
                                            _vm.searchFieldFocus = false
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "display-flex flex-column-reverse laptop:flex-row laptop:flex-items-center flex-content-between",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "display-flex laptop:margin-right-xl flex-content-center size-sm",
                                staticStyle: { gap: "var(--spacing-xs)" },
                              },
                              [
                                _c("search-tabs", {
                                  attrs: {
                                    version: _vm.version,
                                    selected: _vm.selectedTab,
                                  },
                                  on: { applyFilter: _vm.applyFilter },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "display-flex flex-row flex-items-center flex-content-center tablet:flex-content-between flex-wrap margin-bottom-2xl laptop:margin-bottom-0 laptop:margin-left-lg laptop:line-length-xl laptop:line-length-none",
                                staticStyle: {
                                  "--button-margin-bottom": "0",
                                  "--button-background": "transparent",
                                  "--button-color": "var(--fa-navy)",
                                  "--button-font-weight":
                                    "var(--font-weight-normal)",
                                  "--button-hover-color": "var(--fa-dk-blue)",
                                  "--border-color": "var(--fa-lt-gravy)",
                                  "--button-transition-duration":
                                    "var(--timing-2xfast)",
                                  gap: "var(--spacing-xl)",
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "flat icons-facets-menu-toggle with-border laptop:display-none",
                                    staticStyle: {
                                      "flex-grow": "1",
                                      "flex-shrink": "0",
                                      "flex-basis": "auto",
                                      "--button-padding":
                                        "var(--spacing-sm) var(--button-padding-horizontal)",
                                    },
                                    attrs: {
                                      "aria-label": _vm.facetsMenuLabel,
                                      "data-balloon-pos": "up",
                                    },
                                    on: { click: _vm.toggleFacetsMenu },
                                  },
                                  [
                                    _vm.isShowingFacetsMenu
                                      ? _c("font-awesome-icon", {
                                          attrs: {
                                            icon: _vm.$v6.solid.faBarsFilter,
                                            "fixed-width": "",
                                            size: "lg",
                                            flip: "vertical",
                                          },
                                        })
                                      : _c("font-awesome-icon", {
                                          attrs: {
                                            icon: _vm.$v6.solid.faBarsFilter,
                                            "fixed-width": "",
                                            size: "lg",
                                          },
                                        }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.facetsMenuLabel) +
                                        "\n              "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "display-flex flex-items-center",
                                    staticStyle: {
                                      "--input-background": "transparent",
                                      "--input-border-color":
                                        "var(--fa-lt-gravy)",
                                      "--input-box-shadow": "none",
                                      "--input-padding-horizontal":
                                        "var(--spacing-xl)",
                                      "--border-color": "var(--fa-lt-gravy)",
                                      "--button-hover-border-color":
                                        "var(--fa-gravy)",
                                      "--button-active-border-width": "2px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "buttons display-flex margin-x-sm tablet:margin-x-lg",
                                        staticStyle: {
                                          "--button-padding":
                                            "var(--spacing-sm) var(--spacing-md)",
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "flat with-border",
                                            style: {
                                              "--button-color":
                                                _vm.resultsView === "roomy"
                                                  ? "var(--link-color)"
                                                  : "var(--fa-navy)",
                                            },
                                            attrs: {
                                              "aria-label": "Roomy",
                                              "data-balloon-pos": "up",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.changeResultsView(
                                                  "roomy"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: _vm.$v6.solid.faGrid2,
                                                size: "lg",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [
                                                _vm._v(
                                                  "Show icons in roomy display"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "flat with-border",
                                            style: {
                                              "--button-color":
                                                _vm.resultsView === "compact"
                                                  ? "var(--link-color)"
                                                  : "var(--fa-navy)",
                                            },
                                            attrs: {
                                              "aria-label": "Compact",
                                              "data-balloon-pos": "up",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.changeResultsView(
                                                  "compact"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: _vm.$v6.solid.faGrid3,
                                                size: "lg",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [
                                                _vm._v(
                                                  "Show icons in compact display"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "flat with-border",
                                            style: {
                                              "--button-color":
                                                _vm.resultsView === "cheatsheet"
                                                  ? "var(--link-color)"
                                                  : "var(--fa-navy)",
                                            },
                                            attrs: {
                                              "aria-label": "Cheatsheet",
                                              "data-balloon-pos": "up",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.changeResultsView(
                                                  "cheatsheet"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: _vm.$v6.solid.faListDots,
                                                size: "lg",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [
                                                _vm._v(
                                                  "Show icons in cheatsheet display"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("version-selector"),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "margin-top-2xl margin-bottom-6xl" },
                    [
                      _c(
                        "div",
                        { staticClass: "container" },
                        [
                          _vm.isOlderVersion
                            ? _c("wa-old-version-alert", {
                                attrs: { subject: "icons" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "row roomy" }, [
                            _c(
                              "div",
                              {
                                class: [
                                  "column-12 laptop:column-3 desktop:column-2 wrap-icons-facets-menu",
                                  {
                                    "is-container-hidden":
                                      !_vm.isShowingFacetsMenu,
                                  },
                                ],
                              },
                              [
                                _c("wa-carbon-ad", {
                                  attrs: { "has-margin": "" },
                                }),
                                _vm._v(" "),
                                _vm.version !== 5
                                  ? _c("icon-pack-facets", {
                                      attrs: { version: _vm.version },
                                      on: {
                                        scrollTop: _vm.scrollTop,
                                        closeIcon: _vm.closeIcon,
                                        applyFacet: _vm.applyIconPackFacet,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("style-list-facets", {
                                  on: {
                                    scrollTop: _vm.scrollTop,
                                    closeIcon: _vm.closeIcon,
                                    applyFacet: _vm.applyStyleFacet,
                                  },
                                }),
                                _vm._v(" "),
                                _vm.version !== 5
                                  ? _c("visual-tag-facets", {
                                      attrs: { version: _vm.version },
                                      on: {
                                        scrollTop: _vm.scrollTop,
                                        closeIcon: _vm.closeIcon,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("editorial-facets", {
                                  on: {
                                    scrollTop: _vm.scrollTop,
                                    closeIcon: _vm.closeIcon,
                                  },
                                }),
                                _vm._v(" "),
                                _c("category-facets", {
                                  attrs: {
                                    "selected-category": _vm.selectedCategory,
                                  },
                                  on: {
                                    scrollTop: _vm.scrollTop,
                                    closeIcon: _vm.closeIcon,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "form",
                                  {
                                    staticClass:
                                      "form icons-facets-menu display-flex flex-column",
                                    attrs: { id: "icons-facets-menu" },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "sr-only",
                                        attrs: { type: "submit" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Update Icon Results\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "column-12 laptop:column-9 desktop:column-10",
                              },
                              [
                                _c("ais-stats", {
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function ({ nbPages, nbHits, page }) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass:
                                              "icons-results-summary display-flex flex-row flex-wrap flex-items-center laptop:flex-nowrap margin-bottom-xl",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "icons-results-summary-count margin-right-lg",
                                              },
                                              [
                                                _c(
                                                  "h1",
                                                  {
                                                    staticClass:
                                                      "h4 text-nowrap padding-y-5xs",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        nbHits.toLocaleString()
                                                      ) + " Icons"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "icons-results-summary-facets",
                                              },
                                              [
                                                _c("current-facets", {
                                                  attrs: {
                                                    "has-search-term":
                                                      _vm.searchTerm
                                                        ? true
                                                        : false,
                                                  },
                                                  on: {
                                                    clearSearch:
                                                      _vm.clearSearch,
                                                    removeRefinement:
                                                      _vm.removeRefinement,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            nbPages > 1 && !_vm.groupByStyle
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "icons-results-summary-pages margin-left-lg text-right",
                                                    staticStyle: {
                                                      flex: "1 0 auto",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "margin-bottom-0 muted text-nowrap",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "sr-only",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Currently on "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-capitalize",
                                                          },
                                                          [_vm._v("page")]
                                                        ),
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(page + 1) +
                                                            " of " +
                                                            _vm._s(nbPages) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      },
                                    },
                                  ]),
                                }),
                                _vm._v(" "),
                                _c("no-search-results", {
                                  attrs: { version: _vm.version },
                                  on: { clearSearch: _vm.clearSearch },
                                }),
                                _vm._v(" "),
                                _c("icon-list", {
                                  ref: "iconList",
                                  attrs: {
                                    "results-view": _vm.resultsView,
                                    "selected-family": _vm.selectedFamily,
                                    "selected-style": _vm.selectedStyle,
                                    "is-pro-user": _vm.isProUser,
                                    "selected-icon-id": _vm.selectedIconId,
                                    version: _vm.version,
                                    "search-field-focus": _vm.searchFieldFocus,
                                    "group-by-family-style": _vm.groupByStyle,
                                    "has-search-term": _vm.searchTerm
                                      ? true
                                      : false,
                                  },
                                  on: {
                                    toggleIcon: _vm.toggleIcon,
                                    closeIcon: _vm.closeIcon,
                                    viewMore: _vm.viewMore,
                                  },
                                }),
                                _vm._v(" "),
                                _c("modal-icon-detail", {
                                  ref: "iconModal",
                                  attrs: {
                                    "icon-abstract": _vm.iconAbstract,
                                    index: _vm.index,
                                    "selected-from-search": _vm.selectedIcon,
                                    "icon-name": _vm.selectedIconId,
                                    styling: _vm.styling,
                                    "is-pro-user": _vm.isProUser,
                                    "is-showing": _vm.isShowingIconModal,
                                    "is-duotone": _vm.isDuotoneIcon,
                                    "default-styles": _vm.defaultStyles,
                                    viggo: _vm.viggo,
                                  },
                                  on: {
                                    closeIcon: _vm.closeIcon,
                                    selectCategory: _vm.selectCategory,
                                    nextIcon: function ($event) {
                                      return _vm.$refs.iconList.next()
                                    },
                                    prevIcon: function ($event) {
                                      return _vm.$refs.iconList.previous()
                                    },
                                    stylingChange: _vm.stylingChange,
                                    resetStyles: _vm.resetStyles,
                                  },
                                }),
                                _vm._v(" "),
                                !_vm.groupByStyle
                                  ? _c("icons-pagination", {
                                      on: { closeIcon: _vm.closeIcon },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c("wa-page-footer", { attrs: { slot: "footer" }, slot: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }